import { humanDate } from "./humanDate";
export const processDateline = (dateline, pubTime, isSmall, bold) => {
	// inject 'city' class around first part of dateline
	// and add pub date
	let datelineExp = dateline.indexOf(",") > -1 ? dateline.split(",") : false;
	return `<span class="dateline"><span${isSmall || !bold ? "" : ` class="bold"`}>${datelineExp ? `<span class="city">${datelineExp[0].trim()}</span>, ${datelineExp[1].trim()}, ${humanDate(pubTime)}` : `${dateline}, ${humanDate(pubTime)}`}</span></span> — `;
};
// end processDateline function
